"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InfoViews_1 = require("components/newUI/FlashProducts/InfoViews");
var styles = require("./index.scss");
var MFlashProductsCard = (function (_super) {
    __extends(MFlashProductsCard, _super);
    function MFlashProductsCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Info = {
            discount: _this.props.productElement.extra.flash.discount,
            soldOut: _this.props.productElement.stock <= 0,
            isRemindMe: _this.props.productElement.extra.flash.isRemindMe
        };
        _this.setData = function () {
            var _a = _this.props, productElement = _a.productElement, index = _a.index, activeId = _a.activeId, remindMe = _a.remindMe;
            var isRemindMe = _this.Info.isRemindMe;
            var name = productElement.name, gpid = productElement.gpid, start = productElement.start, end = productElement.end;
            var data = {
                isRemindMe: isRemindMe,
                gpid: gpid,
                name: name,
                start: start,
                end: end,
                index: index,
                activeId: activeId
            };
            remindMe(data);
        };
        return _this;
    }
    Object.defineProperty(MFlashProductsCard.prototype, "flashTime", {
        get: function () {
            var timeStamp = Number(this.props.productElement.start) * 1000;
            return new Date(timeStamp).toTimeString().slice(0, 5);
        },
        enumerable: false,
        configurable: true
    });
    MFlashProductsCard.prototype.render = function () {
        var _a = this.props, productElement = _a.productElement, isActView = _a.isActView, state = _a.state, multiTab = _a.multiTab, columnNum = _a.columnNum, spm = _a.spm;
        var _b = this.Info, discount = _b.discount, soldOut = _b.soldOut, isRemindMe = _b.isRemindMe;
        var name = productElement.name, img = productElement.img, price = productElement.price, originPrice = productElement.originPrice, stock = productElement.stock;
        return (React.createElement("div", { className: styles["container_" + columnNum], onClick: function () { return spm(productElement); } },
            React.createElement("div", { className: styles["imgWrap_" + columnNum] },
                InfoViews_1.ImageViews(columnNum, img),
                InfoViews_1.ImageTagViews(isActView, discount, columnNum, soldOut)),
            React.createElement("div", { className: styles["infoContainer_" + columnNum] },
                React.createElement(InfoViews_1.InfoViews, { columnNum: columnNum, isActView: isActView, price: price, originalPrice: originPrice, name: name }),
                React.createElement(InfoViews_1.BottomViews, { columnNum: columnNum, multiTab: multiTab, state: state, stock: stock, soldOut: soldOut, startTime: this.flashTime, isRemindMe: isRemindMe, remindMe: this.setData, price: price, originalPrice: originPrice }))));
    };
    return MFlashProductsCard;
}(React.Component));
exports.default = MFlashProductsCard;
